import React from "react";
import api from "../../../api";

export default function CampaignActionsDropdown({
  campaign,
  onStatusChanged,
  handleViewCampaign,
  handleEditCampaign,
  onWorkingChange,
  profileStatus,
  stirStatus,
  handleDuplicateCampaign
}) {

  const isProfileComplete = profileStatus === "twileo-approved";
  const isStirComplete = stirStatus === "twileo-approved";

  const isDisabled =
    campaign.status === "draft" &&
    (!isProfileComplete || !isStirComplete);

  // ✅ NEW CONDITION
  const canEditOrStart =
    campaign.send_type === "scheduled" ||
    (campaign.send_type === "now" && campaign.status === "pending");

  const handle = async (action) => {
    onWorkingChange && onWorkingChange(true);
    try {
      const res = await api.outbound.updateCampaignStatus(campaign.id, action);
      if (res?.status) {
        onStatusChanged && onStatusChanged({
          status: true,
          message: res.message || "Campaign status updated successfully.",
          action,
        });
      } else {
        onStatusChanged && onStatusChanged({
          status: false,
          message:
            res?.message ||
            "Failed to update campaign status.",
          action,
        });
        onWorkingChange && onWorkingChange(false);
      }
    } catch (e) {
      onStatusChanged && onStatusChanged({
        status: false,
        message:
          e?.response?.data?.message ||
          e?.message ||
          "Failed to update campaign status.",
        action,
      });
      onWorkingChange && onWorkingChange(false);
    }
  };

  return (
    <div className="dropdown">
      <a
        style={{ color: "#087ab6", minWidth: "fit-content" }}
        href="#"
        className="btn btn-icon dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Manage
      </a>

      <div
        className="dropdown-menu dropdown-menu-right yr-custom-menu"
        style={{ minWidth: "max-content" }}
      >
        <ul className="table-list-bg">

          {/* View */}
          <li>
            <a
              className="cursorpointer"
              style={{ display: "flex" }}
              onClick={() => handleViewCampaign(campaign)}
            >
              <i className="fas fa-eye mt-1"></i>
              <span>View</span>
            </a>
          </li>

          {/* ✅ Edit + Actions Block */}
          {canEditOrStart &&
            campaign.status !== "completed" &&
            campaign.status !== "running" && (
              <>
                {/* Edit */}
                <li>
                  <a
                    className="cursorpointer"
                    onClick={() => handleEditCampaign(campaign)}
                  >
                    <i className="fas fa-edit"></i>
                    <span>Edit</span>
                  </a>
                </li>

                {/* Pause / Resume */}
                {campaign.send_type === "scheduled" && (
                  <>
                    {campaign.status === "paused" ? (
                      <li>
                        <a
                          className={isDisabled ? "cursorpointer disabled" : "cursorpointer"}
                          onClick={(e) => {
                            if (isDisabled) {
                              e.preventDefault();
                              e.stopPropagation();
                              return false;
                            }
                            handle("resume");
                          }}
                          style={
                            isDisabled
                              ? {
                                  opacity: 0.5,
                                  cursor: "not-allowed",
                                  pointerEvents: "none",
                                }
                              : {}
                          }
                          title={
                            isDisabled
                              ? "SHAKEN/STIR profile or attestation status must be complete to resume the campaign"
                              : ""
                          }
                        >
                          <i className="fas fa-pause"></i>
                          <span>Resume</span>
                        </a>
                      </li>
                    ) : (
                      (campaign.status === "draft" ||
                        campaign.status === "processing") && (
                        <li>
                          <a
                            className="cursorpointer"
                            onClick={() => handle("pause")}
                          >
                            <i className="fas fa-play"></i>
                            <span>Pause</span>
                          </a>
                        </li>
                      )
                    )}
                  </>
                )}

                {/* Start / Stop */}
                {['stopped','draft','pending'].includes(campaign.status) ? (
                  <li>
                    <a
                      className={isDisabled ? "cursorpointer disabled" : "cursorpointer"}
                      onClick={(e) => {
                        if (isDisabled) {
                          e.preventDefault();
                          e.stopPropagation();
                          return false;
                        }
                        handle("start");
                      }}
                      style={
                        isDisabled
                          ? {
                              opacity: 0.5,
                              cursor: "not-allowed",
                              pointerEvents: "none",
                            }
                          : {}
                      }
                      title={
                        isDisabled
                          ? "SHAKEN/STIR profile or attestation status must be complete to start the campaign"
                          : ""
                      }
                    >
                      <i className="far fa-sticky-note"></i>
                      <span>Start</span>
                    </a>
                  </li>
                ) : (
                  campaign.send_type === "scheduled" && (
                    <li>
                      <a
                        className="cursorpointer"
                        onClick={() => handle("stop")}
                      >
                        <i className="far fa-sticky-note"></i>
                        <span>Stop</span>
                      </a>
                    </li>
                  )
                )}
              </>
            )}

          {/* Duplicate */}
          <li>
            <a
              className="cursorpointer"
              style={{ display: "flex" }}
              onClick={() => handleDuplicateCampaign(campaign)}
            >
              <i className="fas fa-copy mt-1"></i>
              <span>Duplicate</span>
            </a>
          </li>

        </ul>
      </div>
    </div>
  );
}